/** Die Web-App — Ziel von „Im Browser öffnen" (Profil-, Ablage- und Tray-Menü). */
export const WEB_APP_URL = 'https://app.happytask.app'
